import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const reviews = [
  {
    name: "Mr. Aman Diwakar",
    country: "United States",
    image: "/img/team-1.jpg",
    rating: 5,
    review: "Absolutely love this service! Everything was smooth, easy, and professional. Highly recommended for intercity travel!"
  },
  {
    name: "Mr. Kunal M. Thakur",
    country: "United States",
    image: "/img/team-2.jpg",
    rating: 4,
    review: "Super helpful team and great cab platform. Skyline Cabs made it so easy!"
  },
  {
    name: "Miss. Divya Talwar",
    country: "United States",
    image: "/img/team-3.jpg",
    rating: 5,
    review: "Great experience. The booking was seamless and the support team was fantastic."
  },
  {
    name: "Mr. Karan Maheshwari",
    country: "United States",
    image: "/img/team-4.jpg",
    rating: 4,
    review: "Skyline Cabs is my go-to for airport transfers. Reliable and clean cars."
  },
  {
    name: "Miss. Ritika Mathur",
    country: "United States",
    image: "/img/team-5.jpg",
    rating: 5,
    review: "Really impressed with how punctual and professional the driver was. 10/10!"
  }
];


const ReviewCard = ({ name, country, image, rating, review }) => (
  <div className="review-card p-3">
    <div className="card border-0 shadow rounded-4 text-center p-4 h-100">

      <h6 className="fw-bold">{name}</h6>
     
      <div className="mb-2">
        {[...Array(rating)].map((_, i) => (
          <i key={i} className="fa-solid fa-star text-warning me-1"></i>
        ))}
      </div>
      <p className="text-muted fst-italic">"{review}"</p>
    </div>
  </div>
);

const CustomerReviews = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <section
      className="py-5"
      style={{ background: "url(/img/reviewbg.png) no-repeat center center / cover" }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Loving Reviews By Our Customers</h2>
          <p className="text-muted">Cicero famously orated against his political opponent Lucius Sergius Catilina.</p>
        </div>
        <Slider {...settings}>
          {reviews.map((item, idx) => (
            <ReviewCard key={idx} {...item} />
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default CustomerReviews;
